interface Props {
    isActive: boolean
}

const Loader = (props: Props) => {

    if (!props.isActive) {
        return null
    }

    return (
        <div className={`c-loader__container`}>
            <div className="c-loader"></div>
            <p className="c-loader__text">{'Gegevens verwerken...'}</p>
        </div>
    )
}


export default Loader;